import React from 'react';

import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const PinIcon: React.FC<IIconProps> = React.memo(
  ({ stroke = theme.colors['brown-prime'], fill= theme.colors.white, ...props }) => (
    <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.89258 1.25V5.75C7.89258 7.18284 8.91389 8.33644 10.25 8.65723V8.75H5.51172V14.4287L5.47656 14.4619L5.44043 14.4277V8.75H0.75V8.65723C2.08611 8.33644 3.10742 7.18284 3.10742 5.75V1.25H7.89258Z"
        fill={fill}
        stroke={stroke}
        stroke-width="1.5"
      />
    </svg>
  ),
);

export default PinIcon;